import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Header from '../Header';
import Footer from '../Footer';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import config from "../common/Config";
import CommonDatePicker from '../datepicker/CommonDatePicker';

const PushSage = () => {
	const [notPushedList, setNotPushedList] = useState([]);
	const [pushedList, setPushedList] = useState([]);
	const [activeTab, setActiveTab] = useState('notPushed');
	const [salesDates, setSalesDates] = useState([null, null]);
	const [pushedDates, setPushedDates] = useState([null, null]);
	const [reloadPushedTable, setReloadPushedTable] = useState(false);
	const [reload, setReload] = useState(false);
	const token = localStorage.getItem('accessToken');

	// Fetch data when tab changes
	useEffect(() => {
		if (!token) return (window.location.href = `${config.BASE_URL}/login`);
		const ep = activeTab === 'notPushed'
			? 'fetch_not_pushed_list'
			: 'fetch_pushed_list';

		axios
			.post(`${config.API_URL}/${ep}`, {}, { headers: { Authorization: `Bearer ${token}` } })
			.then(res => {
				const d = res.data?.data || [];
				activeTab === 'notPushed'
					? setNotPushedList(d)
					: setPushedList(d);
			})
			.catch(() => Swal.fire('Error', 'Could not load data', 'error'));
	}, [activeTab, token, reload]);

	// Not Pushed Table DataTable logic
	useEffect(() => {
		if (activeTab !== 'notPushed') return;
		if ($.fn.DataTable.isDataTable('#notPushedTable')) $('#notPushedTable').DataTable().destroy();

		setTimeout(() => {
			$('#notPushedTable').DataTable({
				data: notPushedList,
				pageLength: 50,
				ordering: false,
				language: {
					emptyTable: 'No invoices to push.',
					paginate: { first: 'First', last: 'Last', next: 'Next', previous: 'Previous' },
					search: 'Search:'
				},
				columns: [
					{ data: null, title: 'Sr. No.', render: (d, t, r, m) => m.row + 1 },
					{ data: 'invoice_date', title: 'Proforma Inv Date', defaultContent: '-' },
					{ data: 'invoice_date', title: 'Delivery Date', defaultContent: '-' },
					{
						data: 'invoice_number', title: 'Invoice Number',
						render: (v, _, row) =>
							`<a href="${config.BASE_URL}/trip_summary/print/${row.id}" target="_blank">${v || '-'}</a>`
					},
					{ data: 'customer', title: 'Customer Name (Ac/No)', defaultContent: '-' },
					{
						data: 'invoice_amount', title: 'Amount', className: 'text-end',
						render: v => parseFloat(v || 0).toFixed(2)
					},
					{
						data: null, title: 'Action',
						render: (_, __, row) => `<button class="acceptbtn push-btn" data-id="${row.id}">Push</button>`
					}
				]
			})
				.off('click', '.push-btn')
				.on('click', '.push-btn', function () {
					pushInvoice($(this).data('id'));
				});
		}, 0);

		// Cleanup
		return () => {
			if ($.fn.DataTable.isDataTable('#notPushedTable')) $('#notPushedTable').DataTable().destroy();
		};
	}, [notPushedList, activeTab]);

	// Pushed Table DataTable logic
	useEffect(() => {
		if (activeTab !== 'pushed') return;
		if ($.fn.DataTable.isDataTable('#pushedTable')) $('#pushedTable').DataTable().destroy();

		const [startDate, endDate] = pushedDates;
		let formattedStartDate = startDate ? new Date(startDate).toLocaleDateString('en-CA') : '';
		let formattedEndDate = endDate ? new Date(endDate).toLocaleDateString('en-CA') : '';

		setTimeout(() => {
			$('#pushedTable').DataTable({
				processing: true,
				serverSide: true,
				ajax: {
					url: `${config.API_URL}/pushall/invoices`, // Use your actual endpoint for pushed invoices
					type: "POST",
					headers: {
						authorization: `Bearer ${token}`,
					},
					data: function (d) {
						return $.extend({}, d, {
							searchByFromdate: formattedStartDate,
							searchByTodate: formattedEndDate,
							authorization: `Bearer ${token}`,
						});
					},
					dataSrc: function (json) {
						return Array.isArray(json.data) ? json.data : [];
					},
				},
				language: {
					paginate: {
						first: "First",
						last: "Last",
						next: "Next",
						previous: "Previous",
					},
					search: "Search:",
				},
				columns: [
					{ data: null, title: 'Sr. No.', render: (d, t, r, m) => m.row + 1 },
					{ data: 'invoice_date', title: 'Invoiced Date', defaultContent: '-' },
					{
						data: 'invoice_number', title: 'Invoice Number',
						render: (v, _, row) =>
							`<a href="${config.BASE_URL}/trip_summary/print/${row.id}" target="_blank">${v || '-'}</a>`
					},
					{ data: 'customer', title: 'Customer Name (Ac/No)', defaultContent: '-' },
					{
						data: 'invoice_amount', title: 'Invoice Amount', className: 'text-end',
						render: v => parseFloat(v || 0).toFixed(2)
					}
				],
				order: [],
				pageLength: 50,
			});
		}, 0);

		// Cleanup
		return () => {
			if ($.fn.DataTable.isDataTable('#pushedTable')) $('#pushedTable').DataTable().destroy();
		};
	}, [activeTab, pushedDates, reloadPushedTable, token]);

	// Push action
	const pushInvoice = (id) => {
		if (!id) return Swal.fire('Error', 'Invalid invoice ID', 'error');
		const fd = new FormData();
		fd.append('id', id);
		axios.post(`${config.API_URL}/push_invoice`, fd, {
			headers: { Authorization: `Bearer ${token}` }
		})
			.then(r => {
				if (r.data.success) {
					Swal.fire('Success', 'Pushed!', 'success');
					setReload(prev => !prev); // This will re-fetch data for both tables
				} else {
					Swal.fire('Error', r.data.message || 'Push failed', 'error');
				}
			})
			.catch(() => Swal.fire('Error', 'Something went wrong', 'error'));
	};

	const handlePushedDateSubmit = (e) => {
		e.preventDefault && e.preventDefault();
		// This will trigger the useEffect below to reload the table
		setReloadPushedTable(prev => !prev);
	};

	const handleSubmit = (e) => {
		e.preventDefault && e.preventDefault();
		// Add your logic here if needed
	};

	return (
		<>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<a href="#"><i className="fa fa-home"></i></a> &gt; <a href="Dashboard">Account</a> &gt; <span className="last-crumb">Not Pushed</span>
						</div>
					</div>
				</div>
			</div>
			<div className="container-fluid my-4" style={{ minHeight: '100vh', paddingBottom: '100px' }}>
				<ul className="nav nav-tabs mb-3">
					<li>
						<button
							className={`nav-link ${activeTab === 'notPushed' ? 'active' : ''}`}
							onClick={() => setActiveTab('notPushed')}
						>Not Pushed</button>
					</li>
					<li>
						<button
							className={`nav-link ${activeTab === 'pushed' ? 'active' : ''}`}
							onClick={() => setActiveTab('pushed')}
						>Pushed Invoices</button>
					</li>
				</ul>

				<div className="verical-scrl-wrapper common-table pushsage-area" style={{ width: '100%' }}>
					<div className="row">
						<div
							className="col-md-12 col-lg-6 col-sm-12"
							style={{ display: activeTab === 'notPushed' ? '' : 'none' }}
						>

						</div>
						<div
							className="col-md-12 col-lg-6 col-sm-12"
							style={{ display: activeTab === 'pushed' ? '' : 'none', textAlign: 'center', margin: '0px auto -135px auto', position: 'relative', zIndex:'999'}}
						>
							<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
								<CommonDatePicker value={pushedDates} onChange={setPushedDates} style={{ width: '100%' }} />
								<button type="button" className="multisubmit" onClick={handlePushedDateSubmit}>Submit</button>
							</div>
						</div>
					</div>
					<table
						id="notPushedTable"
						className="table table-bordered"
						style={{ width: '100%', display: activeTab === 'notPushed' ? '' : 'none',  }}
					></table>
					<table
						id="pushedTable"
						className="table table-bordered"
						style={{ width: '100%', display: activeTab === 'pushed' ? '' : 'none' }}
					></table>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default PushSage;
